module.exports = {
  title: 'Blur Cards with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-11-28',
  slug: 'blur-cards',
  tags: ['skia', 'reanimated'],
};
